<template>
  <div class="apply-card">
    <div class="card-base card-shadow--small  pr-30 pl-30 pb-22">
      <h2 class="account-info-title">{{$t('applyTradeAccount.selectType')}}</h2>
      <div class="trade-account-box"
           v-for="(item,index) in accountData"
           :key="index">
        <img :src="require(`@/assets/images/account/${item.type}@2x.png`)"
             class="account-img"
             alt="">
        <div class="text-box">
          <div class=" account-name">
            <span>{{translateTradeAccountType(item._tradeAccountType)}}</span>
            <el-tooltip v-if="item.isDormant" popper-class="account-tip" effect="dark"  :content="$t('accountInfo.accountDormant', {accountNumber: item.tradeAccountNumber})" placement="top-start" >
              <span class="what-dormant" >?</span>
            </el-tooltip>
            <span class="account-status" v-if="item.isDormant ">{{$t('common.dormant ')}}</span>
          </div>
          <div class=" account-num"
               v-if="item.status!=='CLOSE' && item.tradeAccountNumber">{{item.tradeAccountNumber}}</div>
        </div>

        <div class="img-tag"
             v-if="item.status">
          <img :src="require(`@/assets/images/account/${accountImgMap[item.status]}${imgSuffix}`)"
          :class="['STOP','CLOSE'].includes(item.status)?'spec-img':''"
               alt="">
        </div>

      </div>
    </div>
    <el-dialog
                :visible.sync="popupVisible"
                width="30%"
                class="fund-box"
                :before-close="handlePopClose"
                :close-on-click-modal="false">
      {{$t('common.dormantTip')}}
      <div class="btn-box btn-box-one">
        <div class="top"
              @click="handlePopClose">{{$t('common.knowIt')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    accountData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isHK() {
      return sessionStorage.getItem('language') === 'hk'
    },
    imgSuffix () {
      let suffix = ''
      const language = sessionStorage.getItem('language')
      if (language === 'hk') {
        suffix = '-f.png'
      } else if (language === 'en') {
        suffix = '-e.png'
      } else {
        suffix = '.png'
      }
      return suffix
    }
  },
  data () {
    return {
      accountImgMap: {
        'SUBMITTED': 'CHECKING',
        'CHECKING': 'CHECKING',
        'PASS': 'OPEN',
        'SUCCESS': 'OPEN',
        'OPEN': 'OPEN',
        'REJECT': 'REJECT',
        'STOP': 'STOP',
        'CLOSE': 'CLOSE'
      },
      popupVisible: false
    }
  },
  methods: {
    translateTradeAccountType (tradeAccountType) {
      return this.$t('tradeAccountType.' + tradeAccountType)
    },
    translateType (type) {
      return this.$t('tradeAccountType.' + type.toUpperCase())
    },
    translateStatus (status) {
      return this.$t('applyTradeAccount.' + status)
    },
    handlePopClose() {
      this.popupVisible = false
    },
    goOpenPage (params, type) {
      if (type && type === 'dormant') {
        console.log(2222)
        this.popupVisible = true
        return
      }
      this.$emit('goOpenPage', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.apply-card {
  .account-info-title {
    font-family: Muli-Bold;
    font-size: 18px !important;
    color: #182a54 !important;
    letter-spacing: 0.22px;
    border-bottom: 3px solid #ebebeb;
    padding: 10px 5px 20px;
  }
  .center {
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .trade-account-box {
    position: relative;
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e0e5f0;
    padding: 20px;
    margin-bottom: 30px;
    .trade-account-card {
      width: 60px;
      height: 60px;
      border-radius: 16px;
      margin-right: 14px;
    }
    .account-img {
      width: 44px;
      height: 44px;
      margin-right: 10px;
    }
    .text-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .account-name {
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 15px;
      }
      .account-num {
        font-size: 15px;
        font-weight: 400;
        color: #666;
        line-height: 15px;
        padding-top: 6px;
      }
    }
    .apply-box {
      background: #3773e1;
      border-radius: 23px;
      padding: 7px 14px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
    }
    .stop-box {
      border-radius: 23px;
      border: 1px solid #3773e1;
      padding: 7px 14px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #3773e1;
      line-height: 18px;
    }
    .img-tag {
      position: absolute;
      right: 0;
      top: 0;
      img {
        // width: 53px;
        height: 20px;
      }
      .spec-img{
        height: 40px;
      }
    }
  }
}
.btn-box-one {
  padding-top: 30px;
  .top {
    margin-bottom: 0;
  }
}
.btn-box {
  font-size: 14px;
  font-weight: 600;
  color: #193060;
  line-height: 20px;
  width: 120px;
  margin: auto;
  text-align: center;

  .top {
    background: #fec000;
    border-radius: 5px;
    padding: 15px 0;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .bottom {
    border-radius: 5px;
    border: 1px solid #193060;
    padding: 15px 0;
    cursor: pointer;
  }
}
.account-status{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #24282D;
  background: #F3F4F6;
  padding: 5px 10px;
  border-radius: 5px;
}
.what-dormant{
 margin-left: 10px;
 cursor: pointer;
}
</style>
<style lang="scss" >
.account-tip{
  width: 400px;
}
</style>
